import { PlusIcon } from "@heroicons/react/outline";
import { FC } from "react";

import { RegistrySelectorProps } from "./types";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const RegistrySelector: FC<RegistrySelectorProps> = ({
  availableRegistries,
  selectedRegistry,
  onSelectRegistry,
  onAddRegistry,
}) => (
  <div className="space-y-2">
    <label className="block text-sm font-medium text-gray-700">Available Prompt Templates</label>
    <div className="flex gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger className="flex-1 rounded-md border border-gray-300 bg-white px-3 py-2 text-left text-sm shadow-sm transition-colors hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
          {selectedRegistry ? (
            <span className="block truncate">{selectedRegistry.prompt_name}</span>
          ) : (
            <span className="block text-gray-500">Select a prompt template</span>
          )}
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[--radix-dropdown-menu-trigger-width]">
          {availableRegistries.map(registry => (
            <DropdownMenuItem key={registry.id} onSelect={() => onSelectRegistry(registry)}>
              {registry.prompt_name}
            </DropdownMenuItem>
          ))}
          {availableRegistries.length === 0 && (
            <div className="px-2 py-1.5 text-sm text-gray-500">
              All prompt templates have been added
            </div>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <Button size="icon" onClick={onAddRegistry} disabled={!selectedRegistry}>
        <PlusIcon className="h-4 w-4" />
      </Button>
    </div>
  </div>
);

export default RegistrySelector;
